__turbopack_context__.v({
  "backgroundImage": "Timeline-module-scss-module__tVHfAq__backgroundImage",
  "backgroundLayer": "Timeline-module-scss-module__tVHfAq__backgroundLayer",
  "content": "Timeline-module-scss-module__tVHfAq__content",
  "currentYear": "Timeline-module-scss-module__tVHfAq__currentYear",
  "drawerRuler": "Timeline-module-scss-module__tVHfAq__drawerRuler",
  "drawerTick": "Timeline-module-scss-module__tVHfAq__drawerTick",
  "drawerTickLg": "Timeline-module-scss-module__tVHfAq__drawerTickLg",
  "drawerTickMd": "Timeline-module-scss-module__tVHfAq__drawerTickMd",
  "drawerTickSm": "Timeline-module-scss-module__tVHfAq__drawerTickSm",
  "drawerYearButton": "Timeline-module-scss-module__tVHfAq__drawerYearButton",
  "drawerYearButtonActive": "Timeline-module-scss-module__tVHfAq__drawerYearButtonActive",
  "drawerYearLine": "Timeline-module-scss-module__tVHfAq__drawerYearLine",
  "drawerYearLineActive": "Timeline-module-scss-module__tVHfAq__drawerYearLineActive",
  "drawerYearRow": "Timeline-module-scss-module__tVHfAq__drawerYearRow",
  "hidden": "Timeline-module-scss-module__tVHfAq__hidden",
  "image": "Timeline-module-scss-module__tVHfAq__image",
  "overlay": "Timeline-module-scss-module__tVHfAq__overlay",
  "reducedMotionEntry": "Timeline-module-scss-module__tVHfAq__reducedMotionEntry",
  "reducedMotionStack": "Timeline-module-scss-module__tVHfAq__reducedMotionStack",
  "rulerTick": "Timeline-module-scss-module__tVHfAq__rulerTick",
  "rulerTickLg": "Timeline-module-scss-module__tVHfAq__rulerTickLg",
  "rulerTickMd": "Timeline-module-scss-module__tVHfAq__rulerTickMd",
  "rulerTickSm": "Timeline-module-scss-module__tVHfAq__rulerTickSm",
  "rulerYearLine": "Timeline-module-scss-module__tVHfAq__rulerYearLine",
  "rulerYearLineAnchor": "Timeline-module-scss-module__tVHfAq__rulerYearLineAnchor",
  "timeWheelArrow": "Timeline-module-scss-module__tVHfAq__timeWheelArrow",
  "timeWheelClose": "Timeline-module-scss-module__tVHfAq__timeWheelClose",
  "timeWheelDrawer": "Timeline-module-scss-module__tVHfAq__timeWheelDrawer",
  "timeWheelDrawerOpen": "Timeline-module-scss-module__tVHfAq__timeWheelDrawerOpen",
  "timeWheelLabel": "Timeline-module-scss-module__tVHfAq__timeWheelLabel",
  "timeWheelOverlay": "Timeline-module-scss-module__tVHfAq__timeWheelOverlay",
  "timeWheelOverlayOpen": "Timeline-module-scss-module__tVHfAq__timeWheelOverlayOpen",
  "timeWheelRuler": "Timeline-module-scss-module__tVHfAq__timeWheelRuler",
  "timeWheelTrigger": "Timeline-module-scss-module__tVHfAq__timeWheelTrigger",
  "timeline": "Timeline-module-scss-module__tVHfAq__timeline",
  "timelineSticky": "Timeline-module-scss-module__tVHfAq__timelineSticky",
  "timelineWrapper": "Timeline-module-scss-module__tVHfAq__timelineWrapper",
  "title": "Timeline-module-scss-module__tVHfAq__title",
  "titleWrapper": "Timeline-module-scss-module__tVHfAq__titleWrapper",
  "verticalLine": "Timeline-module-scss-module__tVHfAq__verticalLine",
  "verticalLineBottom": "Timeline-module-scss-module__tVHfAq__verticalLineBottom",
  "verticalLineTop": "Timeline-module-scss-module__tVHfAq__verticalLineTop",
  "yearNav": "Timeline-module-scss-module__tVHfAq__yearNav",
  "yearWrapper": "Timeline-module-scss-module__tVHfAq__yearWrapper",
});
